import Bugsnag from "@bugsnag/js"

// Bugsnag only starts when window.bugsnagSettings is present (production — see
// app/views/shared/_bugsnag_js.slim). Guarding here keeps notify a no-op
// everywhere else instead of emitting "notify() called before start()"
// warnings in dev and tests.
//
// `sections` maps a Bugsnag tab name to a values object, e.g.
//   notifyBugsnag(error, { thoughtspot: { liveboardId, scope } })
export const notifyBugsnag = (error, sections = {}) => {
  if (!window.bugsnagSettings) return

  Bugsnag.notify(error, (event) => {
    Object.entries(sections).forEach(([section, values]) => {
      event.addMetadata(section, values)
    })
  })
}
